// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-bup","content":"styles_content__1zWZo","row":"styles_row__3na2a","footer":"styles_footer__3iZm4","phraseLength":"styles_phraseLength__23Pf_"};